import { BarChart3, Flag, Scale } from "lucide-react";

export function TrustBar() {
  return (
    <div className="border-y border-border bg-secondary/60 py-3">
      <div className="mx-auto max-w-6xl px-6 lg:px-12">
        <p className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-center text-xs text-muted-foreground sm:text-sm">
          <span className="inline-flex items-center gap-1.5">
            <BarChart3 className="h-4 w-4 text-primary" aria-hidden />
            Calculs basés sur la fiscalité LMNP 2026
          </span>
          <span className="hidden sm:inline">·</span>
          <span className="inline-flex items-center gap-1.5">
            <Flag className="h-4 w-4 text-primary" aria-hidden />
            Conçu en France
          </span>
          <span className="hidden sm:inline">·</span>
          <span className="inline-flex items-center gap-1.5">
            <Scale className="h-4 w-4 text-primary" aria-hidden />
            Conforme régime réel simplifié
          </span>
        </p>
      </div>
    </div>
  );
}
